module.exports = __webpack_public_path__ + "img/jobtype-company.c1714c53.svg";